import React from 'react'

const DivisionContext = React.createContext()

export default DivisionContext 